var _defs, _path, _path2, _circle, _path3, _circle2, _path4, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartiot1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pinGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#60A5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2563EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gaugeGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#22C55E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3B82F6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 86 C34 70, 46 70, 58 86 S82 102, 104 86",
    fill: "none",
    stroke: "#93C5FD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeDasharray: "2 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 34            C40 23.5 48.5 15 59 15            C69.5 15 78 23.5 78 34            C78 48 59 72 59 72            C59 72 40 48 40 34 Z",
    fill: "url(#pinGrad)",
    stroke: "#1D4ED8",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 34,
    r: 6,
    fill: "#FACC15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 84 A26 26 0 0 1 112 84",
    fill: "none",
    stroke: "url(#gaugeGrad)",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 84,
    r: 5,
    fill: "#0F172A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86 84 L102 74",
    stroke: "#0F172A",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 84,
    r: 2.5,
    fill: "#94A3B8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 84,
    r: 2.5,
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartiot1);
export default __webpack_public_path__ + "static/media/smartiot_1.f7a0133301ed74cc55c55ecfb57bb310.svg";
export { ForwardRef as ReactComponent };